import styled, { css } from 'styled-components';
import { defaultTheme } from '@styles/theme.styled';
import { generateScales } from '@helpers/generate-media-queries';

type ColorKey = keyof typeof defaultTheme.colors;

export const QuoteContainer = styled.div<{ fontColor: ColorKey }>`
  ${({ theme, fontColor }) => css`
    width: 100%;
    max-width: 52rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing.lg};
    text-align: center;
    color: ${theme.colors[fontColor]};

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      max-width: unset;
      text-align: left;
      align-items: flex-start;
    }
  `}
`;

export const MainQuoteContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing.sm};

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      align-items: flex-start;
    }
  `}
`;

export const QuoteIconWrapper = styled.div<{ fontColor: ColorKey }>`
  ${({ theme, fontColor }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 3rem;
      height: auto;
    }

    svg path {
      fill: ${theme.colors[fontColor]};
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      svg {
        width: 2.25rem;
      }
    }
  `}
`;

export const QuoteContent = styled.div<{ fontColor: ColorKey }>`
  ${({ theme, fontColor }) => css`
    width: 100%;
    color: ${theme.colors[fontColor]};
    font-family: ${theme.fontFamily.display};
    line-height: ${theme.lineHeights.lg};
    font-size: 1.5rem;

    p {
      margin: 0;
    }

    p + p {
      margin-top: ${theme.spacing.sm};
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      font-size: 1.375rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      font-size: 1.125rem;
    }
  `}
`;

export const Author = styled.footer<{ fontColor: ColorKey }>`
  ${({ theme, fontColor }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.xs};
    color: ${theme.colors[fontColor]};
  `}
`;

export const AuthorName = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
    letter-spacing: 0.02em;
    ${generateScales('font-size', theme.fontSize.body.mobile, theme.fontSize.body.desktop, theme)}
  `}
`;

export const AuthorTitle = styled.span<{ fontColor: ColorKey }>`
  ${({ theme, fontColor }) => css`
    color: ${theme.colors[fontColor]};
    opacity: 0.625;
    ${generateScales('font-size', theme.fontSize.small.mobile, theme.fontSize.small.desktop, theme)}
  `}
`;
